import * as types from '../type/type'

export const setResponsiveState = (state) => ({
  type: types.SET_RESPONSIVE_STATE,
  payload: state,
})
